var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#143271",
    d: "M 21.976562 18.953125 L 31.054688 9.875 C 31.890625 9.039062 31.890625 7.683594 31.054688 6.847656 C 30.222656 6.015625 28.863281 6.011719 28.027344 6.851562 L 18.953125 15.925781 L 9.875 6.851562 C 9.039062 6.015625 7.683594 6.011719 6.847656 6.847656 C 6.015625 7.683594 6.015625 9.039062 6.851562 9.875 L 15.925781 18.953125 L 6.851562 28.027344 C 6.015625 28.863281 6.011719 30.21875 6.847656 31.054688 C 7.683594 31.890625 9.039062 31.890625 9.875 31.054688 L 18.953125 21.976562 L 28.027344 31.054688 C 28.863281 31.890625 30.21875 31.890625 31.054688 31.054688 C 31.890625 30.222656 31.890625 28.863281 31.054688 28.027344 Z M 21.976562 18.953125 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.5fe9afbeea4382c109f076d22ce5713f.svg";
export { ForwardRef as ReactComponent };